import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService, ConfigServerService, CustomHttp} from '../../../core';
import { FormaPagamento } from '../forma-pagamento';
import { FormaPagamentoFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class FormaPagamentoCrudHttpService implements Crud<FormaPagamento> {
    resource = 'formapagamento';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todas as formas de pagamentos */
    search(): Observable<FormaPagamento[]> {
        return this.crudService.search<FormaPagamento>(this.resource);
    }

    searchWithFilter(filter: FormaPagamentoFilter): Observable<FormaPagamento[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<FormaPagamento[]>(this.pathApi, {params});
    }

    /** Procura uma forma de pagamento através do seu ID */
    find(id: number): Observable<FormaPagamento> {
        return this.crudService.find<FormaPagamento>(this.resource, id);
    }

    /** Carrega uma forma de pagamento através do seu ID */
    load(id: number): Observable<FormaPagamento> {
        return this.crudService.load<FormaPagamento>(this.resource, id);
    }

    /** Insere uma nova forma de pagamento */
    insert(entity: FormaPagamento): Observable<FormaPagamento> {
        return this.crudService.insert<FormaPagamento>(this.resource, entity);
    }

    /** Altera uma forma de pagamento existente */
    update(entity: FormaPagamento): Observable<FormaPagamento> {
        return this.crudService.update<FormaPagamento>(this.resource, entity);
    }

    /** Exclui uma forma de pagamento através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
